import { Select } from "antd";
import React from "react";
import { PaymentSchedule } from "../../../../../../types/bookings";
import Grid from "../../../../../atoms/Grid";
import { previewScheduleColumns } from "./previewScheduleColumns";
import { usePreviewScheduleYearFilter } from "./usePreviewScheduleYearFilter";

type PreviewScheduleGridProps = {
  paymentSchedule: PaymentSchedule[];
};

export const PreviewScheduleGrid = (props: PreviewScheduleGridProps) => {
  const { paymentSchedule } = props;
  const { yearOptions, selectedYear, setSelectedYear, shouldEnableYearFilter, filteredData } =
    usePreviewScheduleYearFilter(paymentSchedule);

  return (
    <div>
      {shouldEnableYearFilter && (
        <div style={{ marginBottom: 12, marginLeft: "auto", maxWidth: 220 }}>
          <Select
            style={{ width: "100%" }}
            options={yearOptions}
            value={selectedYear}
            onChange={(value) => setSelectedYear(value)}
          />
        </div>
      )}
      <Grid fullPage className="p-0" columns={previewScheduleColumns} data={filteredData} />
    </div>
  );
};
